import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';

const propsSchema = [
  {
    key: 'bg_img',
    label: 'Background Image',
    type: types.TEXT
  },
  {
    key: 'title',
    label: 'Title',
    type: types.TEXT
  },
  {
    key: 'cta',
    label: 'CTA',
    type: types.OBJECT,
    children: [
      {
        key: 'label',
        label: 'Label',
        type: types.TEXT_WITH_ICON,
        children: [
          { key: 'text', label: 'Text' },
          { key: 'icon', label: 'Icon' },
          { key: 'placement', label: 'Placement' }
        ]
      },
      {
        key: 'url',
        label: 'Url',
        type: types.TEXT
      }
    ]
  },
  {
    key: 'feature_img',
    label: 'Feature Image',
    type: types.TEXT
  },
  {
    key: 'animation',
    label: 'Scroll-in Animation',
    type: types.BOOLEAN
  }
];

const defaultProps = {
  bg_img: 'https://genesis-cdn.ff.com/homepage/06_vr/vr-bg.jpg',
  title: 'https://genesis-cdn.ff.com/homepage/06_vr/genesis-vr-logo.svg',
  cta: {
    label: {
      text: 'experience now',
      icon: 'ff-icon-goggles',
      placement: 'AFTER'
    },
    url: '/vr'
  },
  feature_img: 'https://genesis-cdn.ff.com/homepage/06_vr/genesis-vr-goggles.svg',
  animation: true
};

export default {
  title: 'VR Module',
  id: 'VRModule',
  propsSchema,
  defaultProps
};
